module.exports = __webpack_public_path__ + "img/073648.1c188da6.png";